module.exports = "https://cdn-assessment.mathletics.com/app/112/assets/images/d4ab9ae32d662b18abeceff5e5654ea9.svg";